import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';

import PrimaryButton from './PrimaryButton';
import theme from './theme';

/**
 * Emotion style classes
 */
const padding = '1.5em';

const cardBox = css`
  background-color: ${theme.color.primary};
  box-shadow: 0 3px 12px ${theme.color.shadow};
  padding: ${padding};
`;

const titleSpace = css`
  margin-bottom: 0.25em !important;
`;

const shortDescription = css`
  border-top: 1px solid ${theme.color.highlight};
  color: white;
  padding-bottom: ${padding};
  padding-top: ${padding};
`;

/**
 * Components
 */
const CardBig = ({ text, title, showPopupCard, dataPopupCard }) => (
  <div className="column is-three-quarters">
    <div className={cardBox}>
      <h3 className={`title has-text-white ${titleSpace}`}>{title}</h3>
      <p className={shortDescription}>{text}</p>
      <PrimaryButton handleClick={() => showPopupCard(dataPopupCard)} />
    </div>
  </div>
);

CardBig.propTypes = {
  dataPopupCard: PropTypes.shape({
    body: PropTypes.node,
    title: PropTypes.string,
  }).isRequired,
  showPopupCard: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default CardBig;
